import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useAppStore from "@/stores/useAppStore";
import { GetMe } from "@/apis/Auth";
import { UserStatusEnum } from "@/types/enum";

function useUserStatusCheck() {
  const user = useAppStore((s) => s.user);
  const setUser = useAppStore((s) => s.setUser);
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) return;

    // Check user status every 5 minutes
    const statusCheckInterval = setInterval(() => {
      GetMe().subscribe({
        next: (updatedUser) => {
          // Update user data
          setUser(updatedUser);

          // If user status changed to inactive/suspended, they'll be redirected by AuthRoute
          if (
            updatedUser.status !== UserStatusEnum.ACTIVE &&
            user.status === UserStatusEnum.ACTIVE
          ) {
            // Force a re-render by updating user state
            setUser(updatedUser);
          }
        },
        error: () => {
          // If API fails, redirect to login
          navigate("/login");
        },
      });
    }, 5 * 60 * 1000); // 5 minutes

    return () => {
      clearInterval(statusCheckInterval);
    };
  }, [user, setUser, navigate]);
}

export default useUserStatusCheck;
